<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header border-bottom-1px">

        <!--Provider Charges-->
        <div class="row">
          <div class="col-md-3 margin-top-5px">
            Results
          </div>
                    <div class="col-md-8">
            <div class="row">

              <div class="col-md-9">
                <img class="img-circle width-service-25 margin-right-10px" src='dummy.jpg'>
                <label class="margin-bottom-0px margin-right-5px">Maha,</label>
                <label class="margin-bottom-0px">Female,</label>
                <label class="margin-bottom-0px">35</label>
              </div>
            
            </div>
          </div>
                    <div class="col-md-1 margin-top-5px">
                      <button type="button" class="close" data-dismiss="modal"
                              (click)="activeModal.dismiss('Cross click')"
                              aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
        </div>

      
      </div>

      <div class="modal-body padding-top-0px">
       
       

       

      

        
            <div class="row">

              <div class="col-md-3  padding-right-0px border-right">
                <div class="card">
                  <!--<div class="card-header wh-header header3 padding-left-0px font-size-14 padding-bottom-4px">
                    Select Provider

                  </div>-->
                  <div class="card-body padding-top-0px margin-left-zero padding-left-0px">
                    <div class="row  padding-top-10px padding-bottom-10px margin-right-0px">
                      <div class="col-md-12 padding-right-0px">
                        <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                      </div>


                    </div>
                    <div class="chatsd product-chart-wrapper product-chat-width-92 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                      <div class="row border-bottom rowfor margin-top-11 margin-left-zero nav-link-hand margin-right-0px" (click)="viewprovider()" >
                        <a class=" margin-left-6px">BP</a>
                      </div>
                      <div class="row border-bottom rowfor margin-top-11 margin-left-zero nav-link-hand margin-right-0px" (click)="viewprovider()" >
                        <a class=" margin-left-6px">LBS/FBS</a>
                      </div>
                      <div class="row border-bottom rowfor margin-top-11 margin-left-zero nav-link-hand margin-right-0px" (click)="viewprovider()" >
                        <a class=" margin-left-6px">EL</a>
                      </div>
                      <div class="row border-bottom rowfor margin-top-11 margin-left-zero nav-link-hand margin-right-0px" (click)="viewprovider()" >
                        <a class=" margin-left-6px">GRBS</a>
                      </div>
                    </div>
                    </div>
                  </div>
              </div>



              <div class="col-md-9" *ngIf="ShowService">

                <div class="row">
                  <div class="col-md-12 padding-left-2px padding-right-0px">
                    <div class="card">

                      <div class="card-body margin-left-zero padding-left-8px padding-right-0px padding-top-8px padding-bottom-0px">
                        <div class="row">
                          <!--<div class="col-md-3 text-align-right color"><label class="font-color-secondary">Provider Name</label></div>:-->
                          <div class="col-md-7 text-align-left">
                            
                            <label class="font-size-16px font-weight-bold margin-left-14px margin-top-10">LH</label>
                          </div>
                        </div>
                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero">

                              <thead class="">
                                <tr>
                                 

                                 <th>Date</th>
                                  <th>Value</th>
                                  <th>Remarks</th>
                                 
                                </tr>
                              </thead>
                              <tbody class="table-body">
                                
                                <tr >
                                 

                                  <td class="">
                                  13-JUNE-2019
                                  </td>
                                  <td class="">
                                    <label>100</label>
                                  </td>
                                  

                                  <td class="">
                                    <label>Remarks</label>
                                  </td>



                                </tr>
                                <!--<tr>
                                  <td class="td-padding ">

                                    <input type="checkbox" />

                                    <i class="input-helper"></i>

                                  </td>

                                  <td class="text-align-center">
                                    B1
                                  </td>
                                  <td class="text-align-right">
                                    <label>200</label>
                                  </td>
                                  <td class="td-padding ">
                                    <input type="number" class="form-control" [(ngModel)]="RequestedPositions"
                                           readonly
                                           min="1" max="10" />
                                  </td>
                                  <td class="td-padding ">
                                    <input type="number" class="form-control" [(ngModel)]="RequestedPositions"
                                           readonly
                                           min="1" max="10" />
                                  </td>

                                  <td class="text-align-right">
                                    <a (click)="del_(l.ActorDocPageCode)" class="font-size-16px color-secondary nav-link-hand" title="Save"><i class="far fa-save"></i></a>
                                    <a (click)="del_(l.ActorDocPageCode)" class="font-size-16px color-Rejected margin-left-17px nav-link-hand" title="Remove"><i class="far fa-trash-alt"></i></a>

                                  </td>



                                </tr>-->
                              </tbody>

                            </table>

                          </div>
                        </div>
                       
                        
                      </div>
                      <!--<div class=" card-footer text-align-center">
                        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Cancel</button>
                        <button type="submit" *ngIf='!isRequesting' (click)="gotoservice()" class="btn actions-btn-prime margin-right-auto">Save</button>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
        

          </div>

        

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
      </div>
  </div>
</div>
  
